module.exports = __webpack_public_path__ + "static/media/Boonstra,Simon.9a816c5e.png";